module.exports = __webpack_public_path__ + "img/ico-edit-brand-color.97cb9c3d.svg";